import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    uploader: '文件上传',
    selectFile: '选择文件',
    fileTypeInvalid: '文件的类型不符合要求',
    fileSizeInvalid: '文件的大小不符合要求',
    tooManyFiles: '文件的数量超过限制',
    uploadSuccess: '上传成功！',
    uploadFailure: '上传失败',
    remove: '移除',
    retry: '重试',
    replace: '重新上传',
    cancel: '取消',
    complete: '完成',
    error: '错误！',
    uploading: '上传中…'
  },
  {
    ns: 'uploader'
  }
)
